import React from 'react';

import { Above, Below } from '@jetshop/ui/Breakpoints';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import { styled } from 'linaria/react';

import { theme } from '../../Theme';
import { ActiveFilters } from './ActiveFilters';
import { BooleanFilters } from './BooleanFilters';
import FilterDrawer from './FilterDrawer';
import { ListFilters } from './ListFilters';
import FilterButton from './Mobile/FilterButton';
import { MultiListFilters } from './MultiListFilters';
import { RangeFilters } from './RangeFilters';
import { SortOrders } from './SortOrders';

const Wrapper = styled.div`
   ${theme.above.md} {
      display: grid;
      grid-column-gap: var(--spacing-s, 22px);
      align-items: center;

      grid-template-columns: repeat(4, 1fr);
   }
`;

export const Filter = ({ filters, sortOrders = [] }) => {
   const hasFilters = filters?.length > 0 || sortOrders?.length > 0;

   return (
      <Wrapper>
         <Above breakpoint="md">
            {matches =>
               matches && (
                  <>
                     <ListFilters filters={filters} />
                     <RangeFilters filters={filters} />
                     <MultiListFilters filters={filters} />
                     <SortOrders sortOrders={sortOrders} />
                     <BooleanFilters filters={filters} />
                     <ActiveFilters filters={filters} />
                  </>
               )
            }
         </Above>
         <Below breakpoint="md">
            {matches =>
               matches &&
               hasFilters && (
                  <>
                     <DrawerTrigger id="filterDrawer">
                        {({ showTarget }) => (
                           <FilterButton
                              showTarget={showTarget}
                              filters={filters}
                           />
                        )}
                     </DrawerTrigger>

                     <DrawerTarget id="filterDrawer">
                        {({ hideTarget, isOpen }) => (
                           <Drawer isOpen={isOpen} right>
                              <FilterDrawer
                                 close={hideTarget}
                                 filters={filters}
                                 sortOrders={sortOrders}
                              />
                           </Drawer>
                        )}
                     </DrawerTarget>
                  </>
               )
            }
         </Below>
      </Wrapper>
   );
};

export default Filter;
